module.exports = __webpack_public_path__ + "media/techcrunch-c4f5989e.svg";